import { Template } from '@horasys/bellplus/common/types';

export const GET_TEMPLATES_LIST = 'GET_TEMPLATES_LIST';
export const GET_TEMPLATES_LIST_BY_DEVICE_TYPE = 'GET_TEMPLATES_LIST_BY_DEVICE_TYPE';
export const RESET_TEPLATES_BY_DEVICE_TYPE = 'RESET_TEPLATES_BY_DEVICE_TYPE';
export const RESET_TEMPLATE_FORM = 'RESET_TEMPLATE_FORM';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export interface GetTemplatesAction {
	type: typeof GET_TEMPLATES_LIST;
	payload: Array<Template>;
}

export interface GetTemplatesByDeviceTypeAction {
	type: typeof GET_TEMPLATES_LIST_BY_DEVICE_TYPE;
	payload: Array<Template>;
}
export interface ResetTemplatesByDeviceType {
	type: typeof RESET_TEPLATES_BY_DEVICE_TYPE;
}

export interface ResetTemplateForm {
	type: typeof RESET_TEMPLATE_FORM;
}

export interface AddTemplateAction {
	type: typeof ADD_TEMPLATE;
	payload: Template;
}
export type TemplateAction =
	| GetTemplatesAction
	| GetTemplatesByDeviceTypeAction
	| ResetTemplatesByDeviceType
	| ResetTemplateForm
	| AddTemplateAction;
